import { useQuery } from "@tanstack/react-query";
import {
	getTimerSpeedReport,
	type GetTimerSpeedReportParams,
} from "../repositories/TimerSpeedReportRepository";

type UseTimerSpeedReportParams = Omit<GetTimerSpeedReportParams, "signal">;

export const useTimerSpeedReport = ({
	start,
	end,
}: UseTimerSpeedReportParams) => {
	return useQuery({
		queryKey: ["timerSpeedReport", start, end],
		queryFn: ({ signal }) => getTimerSpeedReport({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
